// =========================================================
// * Vue Material Dashboard - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";

// router setup
import routes from "./routes/routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";

import ApiService from "../src/services/api.service";

import VueDragTree from 'vue-drag-tree'
import 'vue-drag-tree/dist/vue-drag-tree.min.css'
import VueParticles from 'vue-particles'


var location = window.location;
var hostname = location.hostname;
var api = 'https://api.mymemry.com';
var islocal = false;
var CLIENTID = '613025905300-8dtrfk6indutv7fvjra9f80ng1ai60ad.apps.googleusercontent.com';
var ALXID = 'UA-168265258-1';

if(hostname.indexOf('localhost') > -1) {
  api ="http://localhost:3001";
  islocal = true;
  CLIENTID = '599157686914-o090pqndv5c7frmlao1c8gccc4u7mo25.apps.googleusercontent.com';
  
} 

if (hostname.indexOf('webchaver2')  > -1)
  api = "https://memryapi.webchaver2.webfactional.com";

if (hostname.indexOf('memryvueui.web.app') > -1 || hostname.indexOf('amazonaws') > -1  || hostname.indexOf('cloudfront') > -1 )
  api = "https://7hbdf8srb9.execute-api.us-west-2.amazonaws.com/dev/";

 
  //api = "https://7hbdf8srb9.execute-api.us-west-2.amazonaws.com/dev/";
  
if (location.protocol !== 'https:' && !islocal && location.href.indexOf('info') == -1 ) {
    location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

ApiService.init(api);
console.log('hostname',hostname);
console.log('API endpoint',api);


import UtilService from "../src/services/util.service";
UtilService.init();

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});


import VueAnalytics from 'vue-analytics';
if(!islocal) {
  Vue.use(VueAnalytics, {
    id: ALXID,
    router
  });
}

import imageViewer from "vue-image-viewer";
Vue.use(imageViewer);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

/*
import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: '599157686914-o090pqndv5c7frmlao1c8gccc4u7mo25.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
*/
import VueGoogleApi from 'vue-google-api'
  
const config = {
  clientId: CLIENTID,
    scope: 'email profile openid',
  response_type: 'id_token permission'
  //discoveryDocs: [ list_of_discoverydocs_urls ]
}
Vue.use(VueGoogleApi, config)


Vue.prototype.$Chartist = Chartist;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  data: {
    Chartist: Chartist
  }
});
